import { render, staticRenderFns } from "./CogneetivPredictNews.vue?vue&type=template&id=4e49f2b0&scoped=true&"
import script from "./CogneetivPredictNews.vue?vue&type=script&lang=js&"
export * from "./CogneetivPredictNews.vue?vue&type=script&lang=js&"
import style0 from "./CogneetivPredictNews.vue?vue&type=style&index=0&id=4e49f2b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e49f2b0",
  null
  
)

export default component.exports